import { useState } from 'react';
import useEditorSelectedElement from '~/hooks/useEditorSelectedElement';

export const useEffectivelyLocked = () => {
    const [isLocked, setIsLocked] = useState(false);
    const { selectedElement } = useEditorSelectedElement();

    // todo: Remove after BE implements inherited locks
    // useEffect(() => {
    //     setIsLocked(isLockedRecursively(selectedElement));
    // }, [selectedElement]);

    // return isLocked;

    return selectedElement.locked;
};
